/**
 * TRIL-671. Only members with a producer, or a shelved producer, live here.
 *
 * VISIBLE — a producer writes these rows today:
 *   CATEGORY_INTEREST, AUTHORED, FOLLOWING
 *
 * HIDDEN — wanted, not yet built. The member stays so the feature returns in one
 * line; its label is absent from Preferences so no toggle renders:
 *   TRENDING            producer exists but has never run (TRIL-661)
 *   MENTION             nothing exists — no @handle parsing anywhere. QUOTED was
 *                       folded into this: being quoted and being mentioned are the
 *                       same awareness need
 *   REPLY_NOTIFICATION  distinct from being NOTIFIED of a reply, which already
 *                       works (publishPostReply broadcasts `new_replies`). This is
 *                       for replies appearing as feed ROWS
 *
 * REMOVED — no producer and not wanted: QUOTED, LIKED, BOOKMARKED,
 * MUTUAL_INTERACTION, RECOMMENDED (its producer was deleted by TRIL-657).
 *
 * LIKED and BOOKMARKED still exist as `InteractionType` members and power the
 * working /likes and /bookmarks pages. Different enum, different table. Do not
 * conflate them.
 */
export enum FeedEntryType {
  FOLLOWING = 'FOLLOWING', // Shows in feed because user follows author
  REPLY_NOTIFICATION = 'REPLY_NOTIFICATION', // HIDDEN — replies as feed rows, unbuilt
  MENTION = 'MENTION', // HIDDEN — @mention detection, unbuilt
  TRENDING = 'TRENDING', // HIDDEN — producer exists, never run (TRIL-661)
  AUTHORED = 'AUTHORED',
  CATEGORY_INTEREST = 'CATEGORY_INTEREST',
}
